import React from 'react';
import { SELECT_BRANCH_VIEW } from './bankModalSteps';
import type { Bank } from '../../../common/models/banks/bank';
import type { BankBranch } from '../../../common/models/banks/bankBranch';

interface Props {
  bank: Bank;
  branch: BankBranch;
  onTransition: (view: number) => void;
  onOk: () => void;
  onCancel: () => void;
}

export default function BankConfirmView({
  bank,
  branch,
  onTransition,
  onOk,
  onCancel,
}: Props) {
  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header text-center">
          <h5 className="modal-title w-100">確認画面</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span className="popupbank-close">&times;</span>
          </button>
        </div>
        <div className="bank-confirm-body">
          <dl className="bank-confirm">
            <dt>金融機関名</dt>
            <dd>{bank.name}</dd>
          </dl>
          <dl className="bank-confirm">
            <dt>支店名</dt>
            <dd>{branch.name}</dd>
          </dl>
        </div>
        <div className="modal-footer bank-confirm-footer">
          <button
            type="button"
            className="btn btn-lg back-btn btn-outline-secondary mr-20"
            onClick={() => onTransition(SELECT_BRANCH_VIEW)}
          >
            戻る
          </button>
          <button
            type="button"
            className="btn btn-lg btn-flat btn-outline-primary"
            onClick={onOk}
          >
            完了
          </button>
        </div>
      </div>
    </div>
  );
}
